import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-sy-flag',
  standalone: true,
  templateUrl: '../../assets/sy-flag.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSyFlagIcon {}
